import { createAction } from '@reduxjs/toolkit';
import type { RowRelationsEvent } from '~/store/rowRelations/rowRelations.types';

export const rowRelationsEventReceived = createAction('ROW_RELATIONS_EVENT_RECEIVED',
  (event: RowRelationsEvent) => ({ payload: { event } }));
